/**
 * Modal visibility flags. Used by Shell/Modals and the various legal
 * pages that link to the Terms / Privacy / About dialogs.
 */
class ModalStore {
  #listeners = new Set();

  #showPrivacy = false;
  #showTerms = false;
  #showAbout = false;
  #showFAQ = false;

  get showPrivacy() { return this.#showPrivacy; }
  set showPrivacy(v) { this.#showPrivacy = !!v; this.#notify(); }

  get showTerms() { return this.#showTerms; }
  set showTerms(v) { this.#showTerms = !!v; this.#notify(); }

  get showAbout() { return this.#showAbout; }
  set showAbout(v) { this.#showAbout = !!v; this.#notify(); }

  get showFAQ() { return this.#showFAQ; }
  set showFAQ(v) { this.#showFAQ = !!v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#showPrivacy = false;
    this.#showTerms = false;
    this.#showAbout = false;
    this.#showFAQ = false;
    this.#notify();
  }
}

const modalStore = new ModalStore();
export default modalStore;
